import styled from 'styled-components';

export const StatusCellContent = styled.div.attrs<{ className?: string }>({
  className: '[&>p:first-child]:mt-0 md:[&>p:first-child]:mt-2.5',
})`
  position: relative;

  p:first-child {
    font-size: 16px;
    line-height: 130%;
  }
`;
